import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function StorySection() {
  return <section className="mb-16" data-id="element-255">
      <div className="bg-blue-50 p-6 rounded-lg mb-8" data-id="element-256">
        <h2 className="text-2xl font-bold mb-6 text-blue-900" data-id="element-257">
          Margaret's Scary Wake-Up Call
        </h2>
        <div className="text-lg mb-6" data-id="element-258">
          <p className="mb-4" data-id="element-259">
            Margaret S., 74, adored her cat Mr. Mittens. Her retirement joy was
            simple: mornings with her cat on her lap, afternoons hosting book
            club with friends.
          </p>
          <p className="mb-4" data-id="element-260">
            Until one terrifying afternoon changed everything.
          </p>
          <p className="mb-4" data-id="element-261">
            As she brushed Mr. Mittens, Margaret suddenly convulsed in violent
            sneezes. Her chest tightened like a vice. Her lungs locked. She
            gasped for air as her friends panicked, nearly calling 000.
          </p>
        </div>
        <blockquote className="border-l-4 border-blue-500 pl-4 italic text-xl mb-4" data-id="element-262">
          "The wheezing was terrifying. But worse was breaking down crying in
          front of everyone. I felt humiliated."
          <footer className="text-lg font-medium mt-2" data-id="element-263">— Margaret</footer>
        </blockquote>
      </div>
      <div className="flex justify-center" data-id="element-264">
        <img src="https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExbjR0cmN0bXVmZmFhM3Y5cm9zb2dzc2p0MjFocWszMXV3bmI0NWMycCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/cWO07IvGPQXeaNF7P8/giphy.gif" alt="Person petting a black cat and having a coughing fit" className="w-3/2 rounded-lg shadow-md mb-8" data-id="element-265" />
      </div>
      <div className="text-center" data-id="element-266">
        <p className="mb-4 text-lg text-blue-800 text-center" data-id="element-267">
          See How DNRx Works in Your Home
        </p>
        <a href="https://petssey.com/products/petssey-dnrx" className="inline-flex items-center px-8 py-4 text-xl font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 transition-colors" data-id="element-268">
          <span className="mr-2" data-id="element-269">Check Stock Now</span>
          <ArrowRightIcon size={20} data-id="element-270" />
        </a>
      </div>
    </section>;
}